import { PopoverFormFieldWrapper, WrappedInputProps } from '@/common/components/Form/FormFieldWrapper.tsx'
import { useController, useWatch } from 'react-hook-form'
import { FormControl } from '@/common/components/ui/form.tsx'
import React from 'react'
import { SelectOption } from '@/common/types/components.def.ts'
import { useFormSection } from '@/common/components/Form/useFormSection.tsx'
import { Select } from 'antd'

type FormSelectAntdProps = {
  placeholder?: string
  options: SelectOption[]
  disabled?: boolean
  mode?: 'multiple' | 'tags'
} & WrappedInputProps

export const FormSelectAntd: React.FC<FormSelectAntdProps> = ({
  name,
  label,
  description,
  // className,
  wrapperClassName,
  placeholder = 'Please select',
  mode,
  options = [],
  disabled = false,
}) => {
  const { fieldName } = useFormSection(name)
  const { field } = useController({ name: fieldName })
  const value = useWatch({ name: fieldName })

  return (
    <PopoverFormFieldWrapper
      className={wrapperClassName}
      name={name}
      label={label}
      description={description}
      disabled={disabled}
    >
      <FormControl>
        <Select
          allowClear
          mode={mode}
          onClear={() => field.onChange(undefined)}
          value={value}
          onChange={field.onChange}
          disabled={disabled}
          placeholder={placeholder}
          options={options}
        />
      </FormControl>
    </PopoverFormFieldWrapper>
  )
}
